'use client'
import { Button } from '@/components/Button'
import { PageTitle } from '@/components/PageTitle'
import { ITab, Tabs } from '@/components/Tabs'
import { NEW_YEAR_THEME } from '@/config'
import { Mktu } from '@/modules/Mktu'
import { getServiceUrl, goToService } from '@/utils/router'
import cn from 'classnames'
import { observer } from 'mobx-react-lite'
import dynamic from 'next/dynamic'
import Image from 'next/image'
import { FunctionComponent, useCallback, useState } from 'react'
import { Calculator } from '../Calculator'
import { OnlineSearch } from '../OnlineSearch'
import { Select } from '../Select'
import styles from './FirstScreen.module.scss'
import imageCreateApplication from './resources/createApplication.webp'

const ChristmasTree = dynamic(
  () =>
    import('@/modules/NewYearElements/ChristmasTree').then(
      (m) => m.ChristmasTree
    ),
  { ssr: false }
)

enum TAB_TYPE {
  MKTU = 'MKTU',
  CALC = 'CALC',
  SEARCH = 'SEARCH',
  CREATE_APPLICATION = 'CREATE_APPLICATION',
}
const tabsSettings: ITab<TAB_TYPE>[] = [
  {
    value: TAB_TYPE.CREATE_APPLICATION,
    title: 'Подать заявку',
    icon: 'documentAdd',
  },
  // {
  //   value: TAB_TYPE.SEARCH,
  //   title: 'Поиск товарных знаков',
  //   isDisabled: true,
  //   icon: 'scanner',
  // },
  {
    value: TAB_TYPE.CALC,
    title: 'Калькулятор',
    icon: 'calculator2',
  },
  {
    value: TAB_TYPE.MKTU,
    title: 'Подбор классов МКТУ',
    icon: 'addCategory',
  },
  {
    value: TAB_TYPE.SEARCH,
    title: 'Онлайн-поиск',
    icon: 'scanner',
  },
]

type FirstScreenProps = {
  className?: string
}
const FirstScreenComponent: FunctionComponent<FirstScreenProps> = ({
  className,
}) => {
  const [tab, setTab] = useState<TAB_TYPE>(TAB_TYPE.SEARCH)

  const goToApplicationCreate = useCallback(() => {
    goToService(getServiceUrl('/application/create'))
  }, [])

  return (
    <div className={cn(styles.container, className)}>
      <PageTitle
        title={'Электронный сервис для регистрации<br />товарных знаков'}
        className={styles.title}
      />
      {/* {description.length !== 0 ? (
        <div dangerouslySetInnerHTML={{ __html: description }}></div>
      ) : null} */}
      <Tabs
        items={tabsSettings}
        onChange={setTab}
        value={tab}
        className={styles.tabs}
        classNameItem={styles.tab}
      />
      <Select
        className={styles.selectTabs}
        items={tabsSettings}
        onChange={setTab}
        value={tab}
      />
      <Mktu
        className={cn({
          [styles.isHidden]: tab !== TAB_TYPE.MKTU,
        })}
      />
      <Calculator
        className={cn(styles.calculator, {
          [styles.isHidden]: tab !== TAB_TYPE.CALC,
        })}
      />
      <div
        className={cn(styles.createApplication, {
          [styles.isHidden]: tab !== TAB_TYPE.CREATE_APPLICATION,
        })}
      >
        <div className={styles.sectionTitle}>
          Подайте заявку на регистрацию товарного знака
        </div>
        <Button
          onClick={goToApplicationCreate}
          className={styles.createApplicationButton}
        >
          Подать заявку
        </Button>
        <Image
          src={imageCreateApplication}
          alt="Создание заявки"
          width={2336}
          height={1325}
          placeholder="blur"
          className={styles.createApplicationImage}
          sizes="(max-width: 768px) 90vw, (max-width: 1440px) 944px, 1168px"
        />
      </div>
      <div
        className={cn(styles.onlineSearch, {
          [styles.isHidden]: tab !== TAB_TYPE.SEARCH,
        })}
      >
        <OnlineSearch />
      </div>
      {NEW_YEAR_THEME ? <ChristmasTree /> : null}
    </div>
  )
}

export const FirstScreen = observer(FirstScreenComponent)
